import { FormTitle } from '@molecules/*';
import { Button } from '@atoms/*';

export const ThamesWaterPage = () => {
  const title = 'Report this to Thames Water';
  const navigationButton = {
    label: 'Return to homepage',
    isExternalLink: true,
    href: 'https://www.westminster.gov.uk/report-it ',
  };
  return (
    <>
      <FormTitle text={title} />
      <div className="text-bodyLg my-4 flex flex-col gap-4">
        <p>
          We do not deal with burst water main issues. These should be report to{' '}
          <a
            href="https://www.thameswater.co.uk/help/report-a-problem#/view-and-report-problems"
            className="text-action-link underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Thames Water
          </a>
          .
        </p>
      </div>
      <section data-testid="navigate-to-homepage" className="mt-20">
        <Button
          id="navigation-button"
          variant="primary"
          color="navigation-primary"
          label={navigationButton.label}
          isExternalLink={true}
          openInNewTab={true}
          href={navigationButton.href}
        />
      </section>
    </>
  );
};
